function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLandingConditions6 = function SvgLandingConditions6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 363 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_18186_115880)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.488,
    cy: 76.2291,
    rx: 204.449,
    ry: 166.158,
    transform: "rotate(7.1284 299.488 76.2291)",
    fill: "#35FF8D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter1_f_18186_115880)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 299,
    cy: 156.484,
    rx: 121,
    ry: 88.5,
    fill: "#EEFF7C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    },
    filter: "url(#filter2_f_18186_115880)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 386.284,
    cy: 81.1686,
    rx: 185.88,
    ry: 129.902,
    transform: "rotate(-105 386.284 81.1686)",
    fill: "#000873"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_18186_115880",
    x: 0.758591,
    y: -185.409,
    width: 597.459,
    height: 523.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 47.4,
    result: "effect1_foregroundBlur_18186_115880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_18186_115880",
    x: 60.9,
    y: -49.1156,
    width: 476.2,
    height: 411.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.55,
    result: "effect1_foregroundBlur_18186_115880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_18186_115880",
    x: 137.867,
    y: -215.531,
    width: 496.836,
    height: 593.398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 57,
    result: "effect1_foregroundBlur_18186_115880"
  }))));
};
export default SvgLandingConditions6;